import { IonButton, IonContent, IonHeader, IonPage, IonTitle, IonLoading, IonToolbar, useIonToast, IonLabel, IonItemGroup, IonItemDivider, IonItem, IonSelect, IonSelectOption, useIonAlert } from '@ionic/react';
import ExploreContainer from '../components/ExploreContainer';
import './Settings.css';
import { useEffect, useRef, useState } from 'react';
import { logoutUser, getCurrentUserUID, getCurrentUser, changeWorkspace, addOnAuthStateChangedListener, auth, updateDevicePushId, getCurrentUserAuth, sendEmailVerificationToCurrenUser } from '../firebase/firebase';
import { getStoreValue } from '../storage';
import { addSettingsListener } from '../firebase/settings';
import { addWorkspaceListener } from '../firebase/workspace';
import { useHistory } from 'react-router';
import { sendEmailVerification } from '@firebase/auth';
import { addVersionListener, getCurrentVersion, getNewVersion } from '../firebase/version';
import { Capacitor } from '@capacitor/core';


const Settings: React.FC = () => {
    const [presentToast] = useIonToast();
    const [presentAlert] = useIonAlert();
    const [present] = useIonToast();
    const [busy, setBusy] = useState(false);
    const [workspace, setWorkspace] = useState("");
    const [settings, setSettings] = useState<any>();
    const [managerSettings, setManagerSettings] = useState<any>();
    const [workspaces, setWorkspaces] = useState<any>([]);
    const [user, setUser] = useState<any>(getCurrentUser());

    const [newVersion, setNewVersion] = useState(false);
    const [newVersionNumber, setNewVersionNumber] = useState<any>("");

    const workspaceRef = useRef<HTMLIonSelectElement>(null);


    useEffect(() => {
        addWorkspaceListener((companies: any) => {
            setWorkspaces(companies);
            setWorkspace(workspace);
        })
        addOnAuthStateChangedListener((user: any) => {
            setUser(user);

        })

        addSettingsListener((s: any) => {
            for(var i=0; i<s.length; i++){
                switch(s[i].id){
                    case "settings":
                        setSettings(s[i]);
                    break;
                    case "managerSettings":
                        setManagerSettings(s[i]);
                    break;
                }

            }
        });

        addVersionListener((ifNew: boolean) => {
            setNewVersion(ifNew);
            setNewVersionNumber(getNewVersion(".")??"");
        })


    }, []);



    getStoreValue("workspace").then(v => {
        setWorkspace(v);
    });

    async function logout() {
        setBusy(true);
        const res = await logoutUser();
        if (!res) {
            present({
                message: "Wylogowano!",
                duration: 2000,
                position: 'bottom'
            });
            window.history.replaceState({}, '', '/')
        } else {
            present({
                message: "Błąd!",
                duration: 2000,
                position: 'bottom'
            });
        }
        setBusy(false);
    }

    const managerMenu = <IonItemGroup className="ion-padding">
        
                
        <IonItemGroup className="ion-padding">
            <IonItemDivider>
                <IonLabel>
                    SMS
                </IonLabel>
            </IonItemDivider>
            <IonItem>
                <IonLabel>numery</IonLabel>
                <IonLabel>{settings?.allowedSenderNumbers}</IonLabel>
            </IonItem>
            <IonItem>
                <IonLabel>wysłane</IonLabel>
                <IonLabel>{settings?.smsCounter}</IonLabel>
            </IonItem>
            <IonItem>
                <IonLabel>dzień</IonLabel>
                <IonLabel>{settings?.smsDayCounter}/{settings?.smsDayLimit}</IonLabel>
            </IonItem>
            <IonItem>
                <IonLabel>miesiąc</IonLabel>
                <IonLabel>{settings?.smsMonthCounter}/{settings?.smsMonthLimit}</IonLabel>
            </IonItem>
        </IonItemGroup>
        <IonItemGroup className="ion-padding">
            <IonItemDivider>
                <IonLabel>
                    Powiadomienia
                </IonLabel>
            </IonItemDivider>
            <IonItem>
                <IonLabel>Godzina</IonLabel>
                <IonLabel>{managerSettings?.autoReminder ? managerSettings?.autoReminderHour : "wyłączone"}</IonLabel>
            </IonItem>
        </IonItemGroup>

        <IonItemGroup className="ion-padding">
            <IonItemDivider>
                <IonLabel>
                    Raporty
                </IonLabel>
            </IonItemDivider>
            <IonButton expand="block" routerLink='/app/reports'>raporty</IonButton>
        </IonItemGroup>

        <IonItemGroup className="ion-padding">
            <IonItemDivider>
                <IonLabel>
                    Ustawienia
                </IonLabel>
            </IonItemDivider>
            <IonButton routerLink='/app/settings/services' style={{ width: "100%" }}>usługi</IonButton>
            <IonButton routerLink='/app/settings/resources' style={{ width: "100%" }}>pokoje</IonButton>
            <IonButton routerLink='/app/settings/smstemplates' style={{ width: "100%" }}>szablony sms</IonButton>
            <IonButton routerLink='/app/settings/documenttemplates' style={{ width: "100%" }}>szablony dokumentów</IonButton>
            <IonButton routerLink='/app/settings/users' style={{ width: "100%" }}>użytkownicy</IonButton>
        </IonItemGroup>


    </IonItemGroup>;




    async function handleChangeWorkspace() {
        await changeWorkspace(workspaceRef.current?.value);
        getStoreValue("workspace").then(v => {
            setWorkspace(v);
        });
    }

    function emailVerification() {
        sendEmailVerificationToCurrenUser();
        logoutUser();
        presentToast({
            message: "Email weryfikacyjny został wysłany!!",
            duration: 3000,
            position: 'middle'
        });
    }

    function handleNewVersion() {
        if (Capacitor.isNativePlatform()) {
            if (Capacitor.getPlatform() === "ios") {
                var text = "Zgłoś się do ";
                if (getCurrentUser().email === "zaneta@wibako.pl") {
                    text += "kochającego męża ;)";
                } else {
                    text += "Administratora";
                }
                presentAlert({
                    header: "Nowa wersja",
                    subHeader: "",
                    message: text,
                    buttons: ['OK']
                });

            }
            if (Capacitor.getPlatform() === "android") {
                presentAlert({
                    header: "Nowa wersja",
                    subHeader: "",
                    message: "Ściągnij i zainstaluj aplikacje",
                    buttons: [{
                        text: "OK", handler: () => {
                            window.open("https://egabinet.wiq.pl/eGabinet-"+getNewVersion()+".apk");
                        },
                    }]
                });
            }
        } else {
            presentAlert({
                header: "Nowa wersja",
                subHeader: "",
                message: "Odśwież stronę!",
                buttons: ['OK']
            });
        }
    }



    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Ustawienia</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonLoading message="Proszę czekać..." duration={0} isOpen={busy} />
            <IonContent style={{ maxWidth: "800px" }}>
                <IonItemGroup className="ion-padding">
                    <IonItem>
                        <IonLabel>workspace</IonLabel>
                        <IonSelect interface="popover" ref={workspaceRef} value={workspace} placeholder="workspace">
                            {workspaces.map((item: any) => {
                                return <IonSelectOption key={item} value={item}>{item}</IonSelectOption>
                            })}
                        </IonSelect>
                    </IonItem>
                    <IonItem hidden={workspaces.length < 2 && workspace !== null}>
                        <IonLabel>{workspace}</IonLabel>
                        <IonButton slot="end" onClick={handleChangeWorkspace}>przełącz</IonButton>
                    </IonItem>
                    <IonItem>
                        <IonLabel >Zalogowany</IonLabel>
                        <IonLabel>{user !== undefined ? user.email : auth.currentUser?.email}</IonLabel>
                    </IonItem>
                    <IonItem>
                        <IonLabel >Wersja</IonLabel>
                        <IonLabel >{getCurrentVersion()}</IonLabel>
                    </IonItem>

                    <IonItem>
                        <IonButton hidden={!newVersion} color="danger" slot="start" onClick={handleNewVersion} >nowa wersja {newVersionNumber}</IonButton>    
                        <IonButton slot="end" onClick={logout} >wyloguj</IonButton>
                    </IonItem>
                    {!getCurrentUserAuth()?.emailVerified ?
                        <IonItem>
                            <IonButton slot="end" onClick={emailVerification} >weryfikuj email</IonButton>
                        </IonItem>
                        : ""}

                </IonItemGroup>

                {settings !== undefined && user !== undefined && user.role === 'manager' && getCurrentUserAuth()?.emailVerified ? managerMenu : ""}


            </IonContent>
        </IonPage>
    );
};

export default Settings;
